<template>
  <!-- Zehnertastatur fuer Mengen (WMS mobil, Trello 21.08.): Ziffern, eine Stelle zurueck, bestaetigen -->
  <m-sheet :title="title" @close="$emit('close')">
    <div class="m-numpad__display">{{ value || "0" }}</div>
    <div class="m-numpad__grid">
      <button v-for="n in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="n" class="m-numpad__key" @click="append(n)">{{ n }}</button>
      <button class="m-numpad__key m-numpad__key--warn" @click="backspace"><i class="material-icons">backspace</i></button>
      <button class="m-numpad__key" @click="append(0)">0</button>
      <button class="m-numpad__key m-numpad__key--ok" :disabled="!value || value === '0'" @click="confirm"><i class="material-icons">check</i></button>
    </div>
  </m-sheet>
</template>

<script>
import MSheet from "./MSheet.vue";

export default {
  name: "MNumPad",
  components: { MSheet },
  props: {
    title: { type: String, default: "" },
    initial: { type: [String, Number], default: "" },
  },
  data() {
    return { value: String(this.initial || "") };
  },
  methods: {
    append(n) {
      if (this.value.length >= 6) return;
      this.value = this.value === "0" ? String(n) : this.value + String(n);
    },
    backspace() {
      this.value = this.value.slice(0, -1);
    },
    confirm() {
      this.$emit("confirm", parseInt(this.value, 10));
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.m-numpad__display {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  padding: 8px 0 14px;
  color: #263238;
}
.m-numpad__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding-bottom: 8px;
}
.m-numpad__key {
  border: none;
  border-radius: 10px;
  background: #f5f5f5;
  font-size: 24px;
  font-weight: 600;
  padding: 14px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &--warn {
    background: #fff3e0;
    color: #ef6c00;
  }
  &--ok {
    background: #7f915a;
    color: #fff;

    &:disabled {
      opacity: 0.4;
    }
  }
}
</style>
